//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_radiansPerDegree = 0.017453292519943295;\n\
";
